import { useMediaQueries } from "@react-hook/media-query"
import * as R from "remeda"

const makeMediaQuery = (minWidth) => {
  return `screen and (min-width: ${minWidth})`
}

const styles = getComputedStyle(document.documentElement)

const breakpoints = R.pipe(
  {
    sm: styles.getPropertyValue(`--breakpoint-sm`),
    md: styles.getPropertyValue(`--breakpoint-md`),
    lg: styles.getPropertyValue(`--breakpoint-lg`),
    xl: styles.getPropertyValue(`--breakpoint-xl`),
    "2xl": styles.getPropertyValue(`--breakpoint-2xl`),
  },
  R.mapValues(makeMediaQuery),
)

export const useBreakpoints = () => {
  const { matches } = useMediaQueries(breakpoints)

  return matches
}
